export function headerAction() {
  const body = document.querySelector('body');
  const hamburger = document.querySelector('.js-hamburger');
  const entry = document.querySelector('.js-entry');
  const gnav = document.querySelector('.js-gnav');

  hamburger.addEventListener('click', () => {
    if (hamburger.classList.contains('is-active')) {
      body.classList.remove('is-fixed');
      hamburger.classList.remove('is-active');
      entry.classList.remove('is-active');
      gnav.classList.remove('is-view');
    } else {
      body.classList.add('is-fixed');
      hamburger.classList.add('is-active');
      entry.classList.add('is-active');
      gnav.classList.add('is-view');
    }
  });
}
